export function numberWithCommas(x = 0) {
	return Intl.NumberFormat('en-IN').format(x);
}

/**
 * Format a *rate* — keeps up to 4 decimal places, unlike money's fixed 2.
 *
 * warehouse_revenue_slabs_v2.rate_per_order and warehouse_additional_charges_v2.rate
 * are Numeric(10,4): a per-order rate can genuinely need finer than paisa precision
 * (17.5555/order). Rounding it for display made the slab breakdown disagree with the
 * rate the revenue was actually billed at.
 *
 * Mirrors `_rate` in client_invoice_service.py, which formats the same values on the
 * invoice PDF — a whole number shows bare, anything fractional keeps 2 to 4 decimals:
 *   40000   -> '40,000'
 *   17.5    -> '17.50'
 *   17.5555 -> '17.5555'
 *
 * For money (line totals, grand totals, cost heads) keep using numberWithCommas —
 * only rate fields carry the extra precision.
 */
export function rateWithCommas(x = 0) {
	const n = Number(x) || 0;
	if (Number.isInteger(n)) return Intl.NumberFormat('en-IN').format(n);
	return Intl.NumberFormat('en-IN', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 4,
	}).format(n);
}
